import useTranslate from '@root/core/hooks/useTranslate';
import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import { Card, Spin } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import WrapInfo from '../components/detail-sellername/WrapInfo';

import { useActions } from '@root/core/hooks/useActions';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import inventoryService from '@root/modules/Warehouse/Inventory/service/inventory';

const breadcrumbList = [
  {
    tittle: 'Inventory',
    url: '/admin/inventory'
  },
  {
    tittle: 'Seller List',
    url: '/admin/inventory'
  },
  {
    tittle: 'Seller Name',
    url: ''
  }
];

const InventSellName = () => {
  const [t] = useTranslate();
  const { idSellName }: any = useParams();

  const [listName, setListName] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState<
    { tittle: string; url: string }[]
  >([
    {
      tittle: 'Inventory',
      url: '/admin/inventory'
    },
    {
      tittle: 'Seller List',
      url: '/admin/inventory'
    }
  ]);

  const [idInventory, setIdInventory] = useContext<any>(ProductContext);
  setIdInventory(idSellName);

  localStorage.setItem('idSeller', idInventory);

  // send id seller to reducers
  const { getIdSeller } = useActions();

  const getDetailList = async () => {
    setLoading(true);
    const detailList = await inventoryService.getDetailSell(idSellName);
    setListName(detailList.data);
    setBreadcrumb((item) => [
      ...item,
      ...[{ tittle: detailList?.data?.name, url: '' }]
    ]);
    setLoading(false);
  };

  useEffect(() => {
    getDetailList();
    getIdSeller(idSellName);
  }, []);

  return (
    <>
      <Spin spinning={loading} className="loading-forgot">
        <BreadcrumbList listBreadcrumb={breadcrumb} />

        <div className="admin-container ">
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div
              className="wrapIn"
              style={{ display: 'flex', background: 'white', padding: '12px' }}
            >
              <div style={{ paddingRight: '50%' }}>
                <h3 style={{ fontWeight: 'bold' }}>{listName.name}</h3>
                <p>{listName.email}</p>
                <p>{listName.phoneNumber}</p>
              </div>
            </div>
            <WrapInfo />
          </Card>
        </div>
      </Spin>
    </>
  );
};

export default InventSellName;
